import { ChipProps } from "@mui/material";
import {t} from "@lingui/macro";

export function getChipProps(params: string): ChipProps {
    if (params === 'CREATED'){
        return {
            label: t({id: "contact-chip-props.creato", message: "Creata"}),
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "#07568a",
                borderRadius: 1
            },
        }
    }

    if (params === 'ACTIVE'){
        return {
            label: t({id: "contact-chip-props.active", message: "Attivo"}),
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "green",
                borderRadius: 1
            },
        }
    }

    if (params === 'NEGOTIATING'){
        return {
            label: t({id: "contact-chip-props.negotiating", message: "In negoziazione"}),
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "#669cbc",
                borderRadius: 1
            }
        }
    }

    if (params === 'CLOSED'){
        return {
            label: t({id: "contact-chip-props.closed", message: "Chiuso"}),
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "#081839",
                borderRadius: 1
            }
        }
    }

    if (params === 'REJECTED'){
        return {
            label: t({id: "contact-chip-props.rejected", message: "Rifiutato"}),
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "error.main",
                borderRadius: 1
            }
        }
    }


    return {
        label: "Errore",
        color: "error",
        sx: {
            "& .MuiChip-label": {
                color: "background.default"
            },
            borderRadius: 1
        }
    }
}
